
import seoTags from "@/mixins/seoTags";
import { mapGetters } from "vuex";

export default {
	mixins: [seoTags],
	mounted() {
		setTimeout(function () {window.scrollTo(0, -100);}, 1);
	},
	computed: {
		...mapGetters({
			settings: 'settings/settings/settings'
		})
	}
}
